import script from "./AudienceIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceIndex.vue?vue&type=script&setup=true&lang=js"

import "./AudienceIndex.vue?vue&type=style&index=0&id=cd8ff850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd8ff850"]])

export default __exports__